import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { getLocalizedValue, siteContent } from '../../data/siteContent';

const AboutSection = () => {
  const { language } = useLanguage();
  const aboutData = siteContent.about;
  const introText = getLocalizedValue(aboutData.content, language);
  const introPreview = getLocalizedValue(aboutData.mobilePreview, language);
  const featuredLayoutRef = useRef(null);
  const [isIntroExpanded, setIsIntroExpanded] = useState(false);
  const [signupButtonStyle, setSignupButtonStyle] = useState(null);

  useEffect(() => {
    setIsIntroExpanded(false);
  }, [language]);

  useLayoutEffect(() => {
    const updateHeroLayout = () => {
      const layout = featuredLayoutRef.current;

      const isDesktop = window.matchMedia('(min-width: 769px)').matches;
      const menuSignup = document.querySelector('.header .nav-link-cta');

      if (!isDesktop || !layout || !menuSignup) {
        setSignupButtonStyle(null);
        return;
      }

      const layoutRect = layout.getBoundingClientRect();
      const menuRect = menuSignup.getBoundingClientRect();
      const buttonWidth = menuRect.width;
      const buttonPadding = 12;
      const unclampedLeft = menuRect.left - layoutRect.left;
      const maxLeft = layoutRect.width - buttonWidth - buttonPadding;
      const clampedLeft = Math.max(buttonPadding, Math.min(unclampedLeft, maxLeft));

      setSignupButtonStyle({
        left: `${clampedLeft}px`,
        width: `${buttonWidth}px`,
      });
    };

    updateHeroLayout();
    window.addEventListener('resize', updateHeroLayout);

    return () => {
      window.removeEventListener('resize', updateHeroLayout);
    };
  }, [language]);

  const featuredPhoto = (
    <picture className="about-featured-picture">
      <source
        media="(max-width: 768px)"
        srcSet="/images/optimized/agua-bjj-rotterdam-group-photo-640.webp"
      />
      <img
        className="about-featured-photo"
        src="/images/optimized/agua-bjj-rotterdam-group-photo-960.webp"
        srcSet="/images/optimized/agua-bjj-rotterdam-group-photo-960.webp 960w, /images/optimized/agua-bjj-rotterdam-group-photo-1280.webp 1280w"
        sizes="(max-width: 1200px) calc(100vw - 168px), 1032px"
        width="1280"
        height="720"
        decoding="async"
        fetchpriority="high"
        alt=""
      />
    </picture>
  );

  return (
    <section className="section about-section" id="home">
      <div className="container">
        <div className="about-intro-grid">
          <article
            className="about-intro-panel about-intro-panel-featured"
            style={{ '--about-background-image': 'url("/images/optimized/team-agua-gi-1280.webp")' }}
          >
            <div className="about-featured-layout" ref={featuredLayoutRef}>
              <span
                className="about-featured-photo-frame agua-crooked-frame"
                aria-hidden="true"
              >
                {featuredPhoto}
              </span>
              <div className={`about-text about-text-featured ${isIntroExpanded ? 'about-text-expanded' : ''}`}>
                <h1 className="about-title">{getLocalizedValue(aboutData.heroTitle, language)}</h1>
                <p className="about-description">
                  <span className="about-text-full">{introText}</span>
                  <span className="about-text-mobile-preview">
                    {introPreview} ...{' '}
                  </span>
                  <button
                    type="button"
                    className="about-read-more-button"
                    aria-expanded={isIntroExpanded}
                    onClick={() => setIsIntroExpanded((isExpanded) => !isExpanded)}
                  >
                    {getLocalizedValue(isIntroExpanded ? aboutData.readLess : aboutData.readMore, language)}
                  </button>
                </p>
              </div>
              <Link
                to="/signup"
                className="about-card-signup about-mobile-signup nav-link nav-link-cta agua-crooked-frame"
                style={signupButtonStyle || undefined}
              >
                {getLocalizedValue(siteContent.navigation.signup, language)}
              </Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
